import {combineReducers} from 'redux';
import {modalReducer} from "./reducers/modal";
import {loadingReducer} from "./reducers/loading";
import {leadsReducer} from './reducers/leads';
import {campaignReducer} from './reducers/campaign';
import {templatesReducer} from './reducers/template';
import {campaignLeadsRelation} from "./reducers/campaign_leads/reducer";
import {filtersReducer} from "./reducers/filter";
import {authReducer} from "./reducers/auth";
import {logReducer} from "./reducers/log";
import {reportsReducer} from "./reducers/reports";
// import {dialogReducer} from "./reducers/dialogs";
import {statisticsReducer} from "./reducers/statistics";
import {callReducer} from "./reducers/callReducer";
import {taskReducer} from "./reducers/taskReducer";
import {proposalReducer} from "./reducers/proposalReducer";
import {kpiReducer} from "./reducers/kpiReducer";
import {storageExpectedIncomeReducer} from "./reducers/storageExpectedIncome";
import {mcOpsDashboardReducer} from "./reducers/mcOpsDashboard";

export default combineReducers({
    modalData: modalReducer,
    // dialogs: dialogReducer,
    loading: loadingReducer,
    leads: leadsReducer,
    logs: logReducer,
    campaigns: campaignReducer,
    templates: templatesReducer,
    campaigns_leads: campaignLeadsRelation,
    filters: filtersReducer,
    authReducer,
    reports: reportsReducer,
    statisticsReducer,
    callReducer,
    taskReducer,
    proposalReducer,
    kpiReducer,
    storageExpectedIncome: storageExpectedIncomeReducer,
    mcOpsDashboard: mcOpsDashboardReducer,
})
